import React from "react";
import s1 from "../assets/s1.png";
// import as4 from "../assets/as4.png";
// import as1 from "../assets/as1.png";
// import as2 from "../assets/as2.png";
// import as3 from "../assets/as3.png";
import solution from "../assets/solution.png";
import solution1 from "../assets/exchange.png";
import solution2 from "../assets/neural.png";
import solution3 from "../assets/cash-withdrawal.png";
import solution4 from "../assets/files.png";
import solution5 from "../assets/shield.png";
// import v8 from "../assets/Vector 8.png";
// import hiw1 from "../assets/hiw1.png";
// import hiw2 from "../assets/hiw2.png";
// import hiw3 from "../assets/hiw3.png";
// import hiw4 from "../assets/hiw4.png";
// import hiw5 from "../assets/hiw5.png";
// import vs from "../assets/Vector8.png";
import PhoneHeader from "./PhoneHeader";
import benfits from "../assets/benfites.jpg";

const AepsService = () => {
  const data = [
    {
      title: "Financial Inclusion",
      text: "Brings banking to remote or rural areas without branches.",
    },
    {
      title: "Secure & Reliable",
      text: "Uses Aadhaar authentication, reducing fraud risk.",
    },
    {
      title: "No Card Required",
      text: "Works without debit/credit cards or smartphones in some cases.",
    },
    {
      title: "Commission for Agents",
      text: "Agents / BCs can earn commission on each transaction.",
    },
  ];
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container space">
        <div className="text-center top-heading section">
          <h1 className="mb-0">AEPS Services</h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>A</strong> */}
              AEPS offers a range of services designed to simplify financial
              transactions, especially for those who may not have access to
              traditional banking infrastructure. Whether you need to withdraw
              cash, check your account balance, transfer funds, or make
              payments, AEPS makes financial transactions simple and secure.
            </p>
            <ul class="list-unstyled mb-4 mb-md-0">
              <li class="fw-bold mb-2">
                • Secure Aadhaar-based biometric authentication
              </li>
              <li class="fw-bold mb-2">
                • Fast and real-time transaction processing{" "}
              </li>
              <li class="fw-bold mb-2">
                • Supports all major banks (interoperable system)
              </li>
              <li class="fw-bold mb-2">• No need for ATM cards or PINs</li>
              <li class="fw-bold mb-2">
                • Easy setup with minimal infrastructure
              </li>
            </ul>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto img-holl" />
            </div>
          </div>
        </div>

        <div className="section py-5" style={{ backgroundColor: "#FFF6F3" }}>
          <div className="container">
            <div className="row align-items-center">
              {/* Image Column */}
              <div className="col-12 col-lg-6 text-center mb-4 mb-lg-0 d-none d-md-block">
                <img src={solution} alt="AEPS Solution" className="img-fluid" />
              </div>

              {/* Content Column */}
              <div className="col-12 col-lg-6">
                <h2 className="fw-bold mb-4 text-center text-lg-start">
                  Features of Our AEPS Services
                </h2>

                {/* Feature Item */}
                <div className="d-flex mb-4 solution-icon">
                  <div className="solution-icon-wrapper ">
                    <img src={solution5} alt="" className="img-fluid" />
                  </div>
                  <div className="ms-3">
                    <h6 className="fw-bold">
                      Secure & Aadhaar-Based Authentication
                    </h6>
                    <p className="mb-0">
                      Transactions are authenticated using Aadhaar and biometric
                      verification, ensuring high security and reducing fraud.
                    </p>
                  </div>
                </div>

                <div className="d-flex mb-4 solution-icon">
                  <div className="solution-icon-wrapper">
                    <img src={solution1} alt="" className="img-fluid" />
                  </div>
                  <div className="ms-3">
                    <h6 className="fw-bold">Instant Transactions</h6>
                    <p className="mb-0">
                      Cash withdrawal, balance enquiry, and mini statements are
                      processed in real time with immediate confirmation.
                    </p>
                  </div>
                </div>

                <div className="d-flex mb-4 solution-icon">
                  <div className="solution-icon-wrapper">
                    <img src={solution2} alt="" className="img-fluid" />
                  </div>
                  <div className="ms-3">
                    <h6 className="fw-bold">Interoperable Across Banks</h6>
                    <p className="mb-0">
                      Supports transactions for customers of all major banks,
                      regardless of where their Aadhaar is linked.
                    </p>
                  </div>
                </div>

                <div className="d-flex mb-4 solution-icon">
                  <div className="solution-icon-wrapper">
                    <img src={solution3} alt="" className="img-fluid" />
                  </div>
                  <div className="ms-3">
                    <h6 className="fw-bold">Cash Withdrawal Services</h6>
                    <p className="mb-0">
                      Enable customers to withdraw cash conveniently without
                      visiting a bank branch or ATM.
                    </p>
                  </div>
                </div>

                <div className="d-flex solution-icon">
                  <div className="solution-icon-wrapper">
                    <img src={solution4} alt="" className="img-fluid" />
                  </div>
                  <div className="ms-3">
                    <h6 className="fw-bold">
                      Balance Enquiry & Mini Statement
                    </h6>
                    <p className="mb-0">
                      Customers can instantly check their account balance and
                      view recent transactions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-4 section">
          <h2
            className="mt-md-4 mb-md-5"
            style={{ textAlign: "center", fontWeight: "600" }}
          >
            Core AEPS services
          </h2>
          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Cash Withdrawal (DMT - Domestic Money Transfer)
              </h5>
              <p className="mt-2 flex-grow-1 mb-0 text-center text-md-start">
                Users can withdraw cash from their bank accounts via AEPS at
                authorized agents or banking correspondents. This is ideal for
                people who live in remote areas or do not have access to regular
                ATMs.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">Balance Enquiry</h5>
              <p className="mt-2 flex-grow-1 mb-0 text-center text-md-start">
                AEPS allows users to check their account balance using their
                Aadhaar and biometric data. This service is quick, convenient,
                and can be accessed from any AEPS-enabled kiosk or business
                correspondent point.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">Fund Transfer</h5>
              <p className="mt-2 flex-grow-1 mb-0 text-center text-md-start">
                It allows individuals to transfer funds from one account to
                another using Aadhaar-based authentication. This is a secure and
                cost-effective way to send money, especially for those who do
                not have access to formal banking channels.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Aadhaar Pay (Merchant Payments)
              </h5>
              <p className="mt-2 flex-grow-1 mb-0 text-center text-md-start">
                It also enables merchants to accept payments using Aadhaar
                authentication. Customers can pay for goods and services by
                verifying their identity through their Aadhaar number and
                biometric scan.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">Mini Statement</h5>
              <p className="mt-2 flex-grow-1 mb-0 text-center text-md-start">
                Users can request a mini statement of their recent transactions
                using AEPS. This service provides an easy way to track financial
                activity without having to visit the bank.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Aadhaar-Based Biometric Authentication
              </h5>
              <p className="mt-2 flex-grow-1 mb-0 text-center text-md-start">
                Our transactions rely on biometric authentication
                (fingerprint/iris scan), ensuring that only the rightful account
                holder can perform transactions, thus preventing fraud.
              </p>
            </div>
          </div>
        </div>

        {/* <div className="steps-container d-md-block d-none section">
          <div className="my-4">
            <h2 style={{ fontWeight: "700" }}>How It Works</h2>
          </div>

          <div>
            <img src={v8} className="wave-image my-5" alt="wave" />

            <div className="step-box step-1">
              <img src={hiw1} className="icon" />
              <p>A customer visits a business correspondent (BC).</p>
            </div>

            <div className="step-box step-2">
              <p>They provide Aadhaar number & select transaction.</p>
              <img src={hiw2} className="icon" />
            </div>

            <div className="step-box step-3">
              <img src={hiw3} className="icon" />
              <p>Biometric authentication is used.</p>
            </div>

            <div className="step-box step-4">
              <p>Transaction is executed securely.</p>
              <img src={hiw4} className="icon" />
            </div>

            <div className="step-box step-5">
              <img src={hiw5} className="icon" />
              <p>Receipt is printed / SMS is sent.</p>
            </div>
          </div>
        </div> */}

        {/* <div className="mobile-steps d-block d-md-none section">
          <h2 className="fw-bold mb-4 text-center">How It Works</h2>

          <div className="mobile-steps-wrapper">
            <img src={vs} className="mobile-wave" alt="flow" />

            <div className="step-item step1">
              <p>
                A customer visits a business correspondent (BC) or micro-ATM
                equipped agent.
              </p>
              <img src={hiw1} className="step-icon" />
            </div>

            <div className="step-item step2">
              <img src={hiw2} className="step-icon" />
              <p>They provide Aadhaar number & select transaction.</p>
            </div>

            <div className="step-item step3">
              <p>Biometric authentication is used.</p>
              <img src={hiw3} className="step-icon" />
            </div>

            <div className="step-item step4">
              <img src={hiw4} className="step-icon" />
              <p>Transaction is executed securely.</p>
            </div>

            <div className="step-item step5">
              <p>Receipt is printed / SMS is sent.</p>
              <img src={hiw5} className="step-icon" />
            </div>
          </div>
        </div> */}

        {/* benefits */}
        {/* <div className="section d-none d-md-block">
          <h2 className="text-center fw-bold mb-5">Benefits</h2>

          <div className="benefits-wrapper position-relative">
            <div className="benefit"></div>
            <div className="center-line"></div>

            <div className="row align-items-center mb-5">
              <div className="col-6 text-end">
                <div className="benefit-card">
                  <h5 className="fw-bold text-start">Financial Inclusion</h5>
                  <p className="text-start">
                    Brings banking to remote or rural areas without branches.
                  </p>
                </div>
              </div>
              <div className="col-6"></div>
            </div>

            <div className="row align-items-center mb-5">
              <div className="col-6"></div>
              <div className="col-6">
                <div className="benefit-card-1">
                  <h5 className="fw-bold text-start">Secure & Reliable</h5>
                  <p className="text-start">
                    Uses Aadhaar authentication, reducing fraud risk.
                  </p>
                </div>
              </div>
            </div>

            <div className="row align-items-center mb-5">
              <div className="col-6 text-end">
                <div className="benefit-card">
                  <h5 className="fw-bold">No Card Required</h5>
                  <p>
                    Works without debit/credit cards or even smartphones in some
                    cases.
                  </p>
                </div>
              </div>
              <div className="col-6"></div>
            </div>

            <div className="row align-items-center">
              <div className="col-6"></div>
              <div className="col-6">
                <div className="benefit-card-1">
                  <h5 className="fw-bold">Commission for Agents</h5>
                  <p>Agents / BCs can earn commission on each transaction.</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="section d-md-none d-block">
          <h2 className="text-center fw-bold mb-5">Benefits</h2>

          <div className="row justify-content-center">
            {data.map((item, index) => (
              <div className="col-12 mb-3" key={index}>
                <div className="benefit-box text-center p-4">
                  <h5 className="mb-2" style={{ fontWeight: "700" }}>
                    {item.title}
                  </h5>
                  <p className="mb-0">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* <div className="row section key-features">
          <h2 className="text-center mb-5" style={{ fontWeight: "700" }}>
            Key Features
          </h2>
          <div className="col-md-6 col-12">
            <div className="sub-key-features">
              <div className="mb-3 mb-md-0 sub-key-features-img">
                <img src={as4} />
              </div>
              <div>
                <h5 className="mb-2" style={{ fontWeight: "700" }}>
                  Cash Withdrawal
                </h5>
                <p>Withdraw cash from Aadhaar-linked bank accounts.</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <div className="sub-key-features">
              <div className="mb-3 mb-md-0 sub-key-features-img">
                <img src={as1} />
              </div>
              <div>
                <h5 className="mb-2" style={{ fontWeight: "700" }}>
                  Mini Statement
                </h5>
                <p>Get a summary of recent transactions quickly.</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <div className="sub-key-features">
              <div className="mb-3 mb-md-0 sub-key-features-img">
                <img src={as2} />
              </div>
              <div>
                <h5 className="mb-2" style={{ fontWeight: "700" }}>
                  Balance Enquiry
                </h5>
                <p>Instantly check the linked bank account balance.</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <div className="sub-key-features">
              <div className="mb-3 mb-md-0 sub-key-features-img">
                <img src={as3} />
              </div>
              <div>
                <h5 className="mb-2" style={{ fontWeight: "700" }}>
                  Aadhaar-Enabled Payments
                </h5>
                <p>Authenticate transactions using Aadhaar biometrics.</p>
              </div>
            </div>
          </div>
        </div> */}

       <div className="section key-features py-md-5 p-4">
  {/* HEADING */}
  <h2 className="fw-bold text-center mb-4">Benefits of AEPS Service</h2>

  <div className="row align-items-center">
    {/* IMAGE */}
    <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
      <img
        src={benfits}
        alt="Key Features"
        className="img-fluid img-holl"
        style={{ maxWidth: "100%", width: "100%"}}
      />
    </div>

    {/* FEATURE LIST */}
    <div className="col-12 col-md-7 m-auto">
      <ul className="list-unstyled mx-auto">
        <li className="mb-3">• Increased customer footfall</li>
        <li className="mb-3">• Additional source of income</li>
        <li className="mb-3">• Low operational cost</li>
        <li className="mb-3">• Expands digital banking reach</li>
        <li className="">• Builds customer trust and loyalty</li>
      </ul>
    </div>
  </div>
</div>

      </div>
    </>
  );
};

export default AepsService;
